module.exports = __webpack_public_path__ + "img/05.3d709964.svg";